{
  "McpApiUrl": "https://mcp.api.dev.synoptic.com",
  "AppUrl": "https://dev.synoptic.com",
  "TerminalHostedZoneName": "dev.terminal.synoptic.com",
  "Graph2Endpoint": "graph2.dev.synoptic.com",
  "ApiEndpoint": "api.dev.synoptic.com",
  "UserPoolClientId": "nhfstsamdh438h3d9r7ofcjk4",
  "UserPoolEndpoint": "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_XKmsBfgd3",
  "UserPoolId": "us-east-1_XKmsBfgd3",
  "PageScreenshotLambdaUrl": "https://g4g74f3iksd3qr5uu3dh453c5u0artbc.lambda-url.us-east-1.on.aws/",
  "MediaServiceBucketName": "media.dev.synoptic.com",
  "MediaServiceDomainName": "media.dev.synoptic.com",
  "PriceProxyUrl": "https://price-proxy.dev.synoptic.com"
}